export default __webpack_public_path__ + "static/media/event-calendar.dd56e0e2.png";